class Zones {
	constructor() {
		this.section = document.querySelector('.Wizard-chooseType-zone');

		if (this.section) {
			this.onClickVideo();
		}
	}

	/**
	 * Při kliknutí na video se typ reklamy zasune a vysunou se různé formáty video.
	 */
	onClickVideo() {
		const videoInput = this.section.querySelector('#chooseVideo');

		videoInput.addEventListener('change', () => {
			this.section.classList.add('is-open');
		});

		const banner = this.section.querySelector('#chooseBanner');

		banner.addEventListener('change', () => {
			this.section.classList.remove('is-open');
		});
	}
}

export default Zones;
